"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _iconify = require("@iconify/react/dist/iconify.js");
var _material = require("@mui/material");
var _constants = require("../../util/constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DocumentsGridSelected = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var selectedRows = _ref.selectedRows,
    allRows = _ref.allRows,
    callbackSetSelectedRows = _ref.callbackSetSelectedRows,
    onHiddenItemsChange = _ref.onHiddenItemsChange;
  // Only log when selectedRows actually change
  var prevSelectedRowsRef = _react["default"].useRef([]);
  _react["default"].useEffect(function () {
    if (JSON.stringify(selectedRows) !== JSON.stringify(prevSelectedRowsRef.current)) {
      prevSelectedRowsRef.current = selectedRows;
    }
  }, [selectedRows]);
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    expandedFolders = _useState2[0],
    setExpandedFolders = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    hiddenItems = _useState4[0],
    setHiddenItems = _useState4[1];
  var theme = (0, _material.useTheme)();

  // Memoize helper functions to prevent re-creation on every render
  var findItemById = (0, _react.useCallback)(function (id) {
    return allRows.find(function (item) {
      return item.id === id;
    });
  }, [allRows]);
  var getChildren = (0, _react.useCallback)(function (parentId) {
    return allRows.filter(function (item) {
      return item.parentId === parentId;
    });
  }, [allRows]);

  // Memoize expensive calculations
  var getAllDescendants = (0, _react.useCallback)(function (parentId) {
    var children = getChildren(parentId);
    var descendants = children.map(function (child) {
      return child.id;
    });
    var _iterator = _createForOfIteratorHelper(children),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;
        descendants.push.apply(descendants, _toConsumableArray(getAllDescendants(child.id)));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return descendants;
  }, [getChildren]);
  var getAllAncestors = (0, _react.useCallback)(function (itemId) {
    var item = findItemById(itemId);
    if (!(item !== null && item !== void 0 && item.parentId)) return [];
    var ancestors = [item.parentId];
    ancestors.push.apply(ancestors, _toConsumableArray(getAllAncestors(item.parentId)));
    return ancestors;
  }, [findItemById]);

  // Memoize the hierarchy tree construction to avoid expensive recalculations
  var hierarchyTree = (0, _react.useMemo)(function () {
    if (selectedRows.length === 0 || allRows.length === 0) {
      return [];
    }
    var itemsToShow = new Set();

    // For each selected ID, get complete hierarchy (up and down)
    var _iterator2 = _createForOfIteratorHelper(selectedRows),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var id = _step2.value;
        // Skip if this item is hidden
        if (hiddenItems.includes(id)) continue;

        // Add the selected item itself
        itemsToShow.add(id);

        // Add all ancestors (going up)
        var ancestors = getAllAncestors(id);
        var _iterator4 = _createForOfIteratorHelper(ancestors),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var ancestorId = _step4.value;
            if (!hiddenItems.includes(ancestorId)) {
              itemsToShow.add(ancestorId);
            }
          }

          // Add all descendants (going down)
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        var descendants = getAllDescendants(id);
        var _iterator5 = _createForOfIteratorHelper(descendants),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var descendantId = _step5.value;
            if (!hiddenItems.includes(descendantId)) {
              itemsToShow.add(descendantId);
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }

      // Build the tree structure recursively
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    var _buildNode = function buildNode(itemId, level) {
      var item = findItemById(itemId);
      if (!item || hiddenItems.includes(itemId)) return null;
      var children = [];

      // Get all direct children of this item that should be shown
      var directChildren = getChildren(itemId);
      var _iterator3 = _createForOfIteratorHelper(directChildren),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var child = _step3.value;
          if (itemsToShow.has(child.id) && !hiddenItems.includes(child.id)) {
            var childNode = _buildNode(child.id, level + 1);
            if (childNode) {
              children.push(childNode);
            }
          }
        }

        // Sort children: folders first, then files, then alphabetically
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      var sortedChildren = [].concat(children).sort(function (a, b) {
        if (a.item.fileType === _constants.TYPE_FOLDER && b.item.fileType !== _constants.TYPE_FOLDER) return -1;
        if (a.item.fileType !== _constants.TYPE_FOLDER && b.item.fileType === _constants.TYPE_FOLDER) return 1;
        return a.item.documentName.localeCompare(b.item.documentName);
      });
      return {
        item: item,
        children: sortedChildren,
        level: level
      };
    };

    // Find root items (items without parents or whose parents are not in the tree)
    var rootItems = Array.from(itemsToShow).filter(function (id) {
      var item = findItemById(id);
      return !hiddenItems.includes(id) && (!(item !== null && item !== void 0 && item.parentId) || !itemsToShow.has(item.parentId));
    });

    // Build tree from root items
    var tree = rootItems.map(function (rootId) {
      return _buildNode(rootId, 0);
    }).filter(function (node) {
      return node !== null;
    });

    // Sort root items: folders first, then files, then alphabetically
    var sortedTree = _toConsumableArray(tree).sort(function (a, b) {
      if (a.item.fileType === _constants.TYPE_FOLDER && b.item.fileType !== _constants.TYPE_FOLDER) return -1;
      if (a.item.fileType !== _constants.TYPE_FOLDER && b.item.fileType === _constants.TYPE_FOLDER) return 1;
      return a.item.documentName.localeCompare(b.item.documentName);
    });
    return sortedTree;
  }, [selectedRows, allRows, hiddenItems, findItemById, getChildren, getAllAncestors, getAllDescendants]);

  // Helper function to check and hide empty parent folders recursively
  var checkAndHideEmptyParents = (0, _react.useCallback)(function (childId, itemsToHideLocal, currentHiddenItems) {
    var child = findItemById(childId);
    if (!(child !== null && child !== void 0 && child.parentId)) return;
    var parent = findItemById(child.parentId);
    if ((parent === null || parent === void 0 ? void 0 : parent.fileType) !== _constants.TYPE_FOLDER) return;

    // Get all children of the parent
    var siblings = getChildren(parent.id);

    // Check if all siblings will be hidden after this operation
    var allSiblingsHidden = siblings.every(function (sibling) {
      return itemsToHideLocal.includes(sibling.id) || currentHiddenItems.includes(sibling.id);
    });
    if (allSiblingsHidden) {
      // Hide the parent folder too
      itemsToHideLocal.push(parent.id);
      // Recursively check the parent's parent
      checkAndHideEmptyParents(parent.id, itemsToHideLocal, currentHiddenItems);
    }
  }, [findItemById, getChildren]);

  // Helper function to collect items to remove from selection
  var collectItemsToRemove = (0, _react.useCallback)(function (itemId, item, uniqueItemsToHide) {
    var itemsToRemove = [];

    // If the item itself is directly selected, remove it
    if (selectedRows.includes(itemId)) {
      itemsToRemove.push(itemId);

      // If it's a folder, also remove all its descendants that are selected
      if (item.fileType === _constants.TYPE_FOLDER) {
        var descendants = getAllDescendants(itemId);
        var _iterator6 = _createForOfIteratorHelper(descendants),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var descendantId = _step6.value;
            if (selectedRows.includes(descendantId)) {
              itemsToRemove.push(descendantId);
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    }

    // Also remove any parent folders that became empty and are selected
    var _iterator7 = _createForOfIteratorHelper(uniqueItemsToHide),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var hiddenId = _step7.value;
        if (selectedRows.includes(hiddenId)) {
          itemsToRemove.push(hiddenId);
        }
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
    return itemsToRemove;
  }, [selectedRows, getAllDescendants]);

  // Function to handle item removal with hierarchy logic
  var handleRemoveItem = (0, _react.useCallback)(function (itemId) {
    var item = findItemById(itemId);
    if (!item) return;

    // ALWAYS hide the item immediately for visual feedback
    var itemsToHideLocal = [itemId];

    // If it's a folder, also hide all its descendants
    if (item.fileType === _constants.TYPE_FOLDER) {
      var descendants = getAllDescendants(itemId);
      itemsToHideLocal.push.apply(itemsToHideLocal, _toConsumableArray(descendants));
    }

    // Check if parent folders should also be hidden (if they become empty)
    checkAndHideEmptyParents(itemId, itemsToHideLocal, hiddenItems);

    // Update hidden items first for immediate visual feedback
    var uniqueItemsToHide = _toConsumableArray(new Set(itemsToHideLocal));
    var newHiddenItems = [].concat(_toConsumableArray(hiddenItems), _toConsumableArray(uniqueItemsToHide));
    setHiddenItems(newHiddenItems);
    onHiddenItemsChange === null || onHiddenItemsChange === void 0 || onHiddenItemsChange(newHiddenItems);

    // Collect and remove items from selection
    var itemsToRemove = collectItemsToRemove(itemId, item, uniqueItemsToHide);
    var uniqueItemsToRemove = _toConsumableArray(new Set(itemsToRemove));
    if (uniqueItemsToRemove.length > 0) {
      callbackSetSelectedRows(uniqueItemsToRemove);
    }
  }, [hiddenItems, findItemById, getAllDescendants, checkAndHideEmptyParents, collectItemsToRemove, callbackSetSelectedRows, onHiddenItemsChange]);

  // Reset hidden items only when selectedRows change substantially (not just removals)
  // We detect this by checking if new items were added (length increased)
  (0, _react.useEffect)(function () {
    var prevLength = prevSelectedRowsRef.current.length;
    var currentLength = selectedRows.length;

    // Only reset hidden items if selection increased or completely changed
    if (currentLength > prevLength) {
      setHiddenItems([]);
      onHiddenItemsChange === null || onHiddenItemsChange === void 0 || onHiddenItemsChange([]);
      return;
    }

    // Check if any previously hidden item is now selected again
    var hiddenItemsNowSelected = hiddenItems.filter(function (hiddenId) {
      return selectedRows.includes(hiddenId);
    });
    if (hiddenItemsNowSelected.length > 0) {
      // Remove these items from hidden list since they're selected again
      var newHiddenItems = hiddenItems.filter(function (id) {
        return !hiddenItemsNowSelected.includes(id);
      });
      setHiddenItems(newHiddenItems);
      onHiddenItemsChange === null || onHiddenItemsChange === void 0 || onHiddenItemsChange(newHiddenItems);
      return;
    }

    // Clean up hidden items that are no longer in the hierarchy
    // (their parent folders were deselected)
    var filteredHiddenItems = hiddenItems.filter(function (hiddenId) {
      var item = findItemById(hiddenId);
      if (!item) return false;

      // Check if any ancestor is still selected
      var ancestors = getAllAncestors(hiddenId);
      return ancestors.some(function (ancestorId) {
        return selectedRows.includes(ancestorId);
      });
    });
    if (filteredHiddenItems.length !== hiddenItems.length) {
      setHiddenItems(filteredHiddenItems);
      onHiddenItemsChange === null || onHiddenItemsChange === void 0 || onHiddenItemsChange(filteredHiddenItems);
    }
  }, [selectedRows, hiddenItems, findItemById, getAllAncestors, onHiddenItemsChange]); // Helper functions to handle folder expand/collapse
  var expandFolder = (0, _react.useCallback)(function (itemId) {
    setExpandedFolders(function (prev) {
      return [].concat(_toConsumableArray(prev), [itemId]);
    });
  }, []);
  var collapseFolder = (0, _react.useCallback)(function (itemId) {
    setExpandedFolders(function (prev) {
      return prev.filter(function (id) {
        return id !== itemId;
      });
    });
  }, []);

  // Memoize the render function to prevent unnecessary re-renders
  var renderNode = (0, _react.useCallback)(function (node) {
    var item = node.item,
      children = node.children,
      level = node.level;
    var isExpanded = expandedFolders.includes(item.id);
    var hasChildren = children.length > 0;
    var isDirectlySelected = selectedRows.includes(item.id);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: item.id
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex space-between align-items-center",
      style: {
        paddingRight: "10px",
        height: "2rem",
        paddingLeft: "".concat(level * 20, "px")
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex gap-8 align-items-center",
      style: {
        width: "90%"
      }
    }, item.fileType === _constants.TYPE_FOLDER && hasChildren && /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
      icon: isExpanded ? "mdi-light:chevron-up" : "mdi-light:chevron-down",
      width: 20,
      height: 20,
      color: "#1C1B1F",
      className: "cursor-pointer",
      onClick: function onClick() {
        return isExpanded ? collapseFolder(item.id) : expandFolder(item.id);
      }
    }), !(item.fileType === _constants.TYPE_FOLDER && hasChildren) && /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: 20
      }
    }), /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
      icon: item.fileType === _constants.TYPE_FOLDER ? "material-symbols-light:folder-outline-rounded" : "mdi:file-outline",
      width: 20,
      height: 20,
      color: "#1C1B1F"
    }), /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        textOverflow: "ellipsis",
        overflow: "hidden",
        width: "90%",
        lineBreak: "normal",
        whiteSpace: "nowrap",
        opacity: isDirectlySelected ? 1 : 0.6,
        // Dim items that are not directly selected
        fontWeight: isDirectlySelected ? "bold" : "normal"
      },
      title: item.documentName
    }, item.documentName)), /*#__PURE__*/_react["default"].createElement(_iconify.Icon, {
      icon: "zondicons:minus-outline",
      className: "cursor-pointer",
      style: {
        overflow: "visible"
      },
      width: 13,
      color: theme.palette.primary.main,
      onClick: function onClick() {
        handleRemoveItem(item.id);
      }
    })), item.fileType === _constants.TYPE_FOLDER && hasChildren && isExpanded && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children.map(function (child) {
      return renderNode(child);
    })));
  }, [expandedFolders, selectedRows, theme.palette.primary.main, handleRemoveItem, expandFolder, collapseFolder]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hierarchyTree.length > 0 && /*#__PURE__*/_react["default"].createElement("div", null, hierarchyTree.map(function (node) {
    return renderNode(node);
  })));
});
DocumentsGridSelected.displayName = "DocumentsGridSelected";
var _default = exports["default"] = DocumentsGridSelected;